/* eslint-disable max-len */
import React from 'react'
import { useState, useRef } from 'react'
// import { useOnClickOutside } from '../../CommonMethods/OutsideClick';
export default function InputBox({
    label,
    placeholder,
    htmlFor,
    id,
    value,
    isUnit,
    isCode,
    countryCodeList,
    country_code,
    countryCodeVal,
    setCountryCodeVal,
    unitType,
    index,
    usernameError,
    sessionError,
    maxFailError,
    emptyField,
    emailError,
    handleOnChangeInput,
    data_testid,
    disabled,
    maxLength,
    handleSelectCountryCode,
    preferences
    

}) {
    const [isOpen, setisOpen] = useState(false)
    const ref = useRef();
    // useOnClickOutside(ref, () => {
    //     setisOpen(false);
    // });

    
    return (
        <div className='flex flex-col' ref={ref}>
            {label !== "" && <label htmlFor={htmlFor} className='text-xs font-semibold text-[#000] mb-1.5 more-lines' title={label}>{label}</label>}
            {/* border-[#D3454D] */}
            <div className='relative'>
                <input
                    maxLength={maxLength}
                    data-testid={data_testid}
                    type="text"
                    id={id}
                    
                    onInput={(e) => {
                        if (id === "serial_number") {
                            // Replace non-numeric characters with an empty string
                            e.target.value = e.target.value.replace(/[^0-9a-zA-Z]/g, '');
                        }
                    }}
                    onWheel={e => e.target.blur()}
                    autoComplete="off"
                    value={value}
                    disabled={disabled}
                    onChange={(e) => {
                        disabled ? '' :
                            index!==undefined?handleOnChangeInput(id, e.target.value,index):handleOnChangeInput(id, e.target.value)
                    }}
                    className={`border ${emptyField || emailError || sessionError || maxFailError || usernameError  ? 'border-[#C81720]' : 'border-[#C5C9DA] '} rounded-lg pl-3.5 ${isUnit ? 'pr-[80px]' : 'pr-3.5'} ${isCode ? 'pl-[94px]' : 'pl-4'} py-[11px] text-base font-normal 
                text-[#000B17] w-full disabled:cursor-not-allowed disabled:bg-[#E7EAF4] placeholder:text-[#52555D] placeholder:text-sm outline-none appearance-none`} placeholder={placeholder} />
                {isUnit && <div className='border-l border-[#E7EAF4] absolute top-1/2 right-0 w-[74px] py-1.5 -translate-y-1/2'>
                    <p className='text-xs font-semibold text-[#52555D] pl-2.5'>{unitType}</p>
                </div>}
                {isCode && <>
                    <button  onClick={() => setisOpen(!isOpen)} className='absolute top-[50%] -translate-y-[50%] left-4 text-base font-normal text-[#000000] flex items-center justify-between w-[74px]'>
                        <p className='pr-0.5'>{(countryCodeVal === ""||countryCodeVal===undefined) ? country_code : countryCodeVal}</p>
                        <img loading='lazy' decoding='async' src="/images/dropdown_green.svg" alt="icon" className={`${isOpen ? "transform rotate-180" : ""}`} />
                    </button>
                    <ul className={`absolute top-[50px] z-50 left-0 p-2 rounded-lg border border-[#C5C9DA] w-[104px] bg-white h-fit ${isOpen ? "" : "hidden"}`}>
                        <li>
                            <ul className='max-h-[150px] overflow-auto bg-white pr-1 scrollbar_gray_thin '>
                                {countryCodeList?.map((item, index) => (
                                    <li key={index}>
                                        <p  onClick={()=>{handleSelectCountryCode(item), setisOpen(false)}}className={`text-sm font-normal cursor-pointer  ${item===countryCodeVal?`text-base text-[#008586]`:'text-sm font-normal text-[#000]'} hover:text-[#008586] mb-2`}>{item}</p>
                                    </li>
                                ))}
                            </ul>
                        </li>
                    </ul>
                </>
                }
            </div>
        </div>
    )
}
